/**
 * `patient_response` trae marcas de actuación entre corchetes —"[suspiro]",
 * "[aclara la garganta]"— que son instrucciones para la voz, no texto del
 * paciente. En la transcripción que ve el alumno se ocultan (decisión de la
 * tanda 2, 2026-09-19). El diagnóstico conserva el texto original.
 */
export function limpiarMarcas(texto: string): string {
  return texto
    .replace(/\[[^\]]*\]/g, ' ')
    .replace(/\s+([,.;:!?¡¿…])/g, '$1')
    .replace(/\s{2,}/g, ' ')
    .trim();
}
